import React from 'react';
import { useAdminAnalytics } from './analytics/useAdminAnalytics';
import { AnalyticsStatus, DateRangeToolbar } from './analytics/AnalyticsStatus';
import GrowthChartSection, { PeriodGrowthTables } from './analytics/GrowthChartSection';
import GuestFunnelSection from './analytics/GuestFunnelSection';
import PlanWaitlistPanel from './PlanWaitlistPanel';
import '../../styles/AdminDashboard.css';

export default function AdminGrowthPage() {
  const analytics = useAdminAnalytics({
    title: 'Growth',
    subtitle: 'Daily, weekly and monthly signups and the public guest-save funnel',
  });

  const {
    analyticsData,
    loading,
    refreshing,
    error,
    isAuthenticated,
    lastUpdatedAt,
    growthRangeDraft,
    growthRangeApplied,
    growthRangeError,
    analyticsRangePreset,
    funnelTrendShowSubmits,
    setFunnelTrendShowSubmits,
    funnelTrendShowMerges,
    setFunnelTrendShowMerges,
    fetchAnalytics,
    applyFunnelPreset,
    handleGrowthRangeDraftChange,
    applyGrowthRange,
    clearGrowthRange,
    palette,
    dailyUsersData,
    guestFunnelDailyData,
  } = analytics;

  return (
    <>
    <AnalyticsStatus
      loading={loading}
      error={error}
      isAuthenticated={isAuthenticated}
      analyticsData={analyticsData}
      onRetry={() => fetchAnalytics()}
    >
    {analyticsData ? (
      <div className="admin-dashboard">
        {refreshing ? (
          <p className="adminMutedText" style={{ marginTop: 0 }}>Updating…</p>
        ) : null}

        <DateRangeToolbar
          analyticsRangePreset={analyticsRangePreset}
          growthRangeApplied={growthRangeApplied}
          growthRangeDraft={growthRangeDraft}
          growthRangeError={growthRangeError}
          lastUpdatedAt={lastUpdatedAt}
          loading={loading || refreshing}
          onPreset={applyFunnelPreset}
          onDraftChange={handleGrowthRangeDraftChange}
          onApply={applyGrowthRange}
          onClear={clearGrowthRange}
          hint="This UTC window drives daily user growth, the guest-save funnel, and average session duration on Users. Weekly and monthly tables stay on a rolling 12-period view."
        />

        <div className="analytics-section" style={{ marginTop: 16 }}>
          <h2>Growth Analytics</h2>
          <GrowthChartSection
            dailyUsersData={dailyUsersData}
            palette={palette}
            analyticsRangePreset={analyticsRangePreset}
            growthRangeApplied={growthRangeApplied}
            lastUpdatedAt={lastUpdatedAt}
          />
        </div>

        <PeriodGrowthTables
          weekly={analyticsData.growth?.weekly || []}
          monthly={analyticsData.growth?.monthly || []}
        />

        <GuestFunnelSection
          gf={analyticsData.guestFunnel}
          palette={palette}
          guestFunnelDailyData={guestFunnelDailyData}
          funnelTrendShowSubmits={funnelTrendShowSubmits}
          setFunnelTrendShowSubmits={setFunnelTrendShowSubmits}
          funnelTrendShowMerges={funnelTrendShowMerges}
          setFunnelTrendShowMerges={setFunnelTrendShowMerges}
        />
      </div>
    ) : null}
    </AnalyticsStatus>
    <div className="admin-dashboard">
      <PlanWaitlistPanel />
    </div>
    </>
  );
}
